export const categories = [
  { slug: 'wanghong', name: '网红爆料', icon: 'ri-user-star-line', count: 1286 },
  { slug: 'zhubo', name: '主播大瓜', icon: 'ri-live-line', count: 954 },
  { slug: 'bozhu', name: '博主反差', icon: 'ri-camera-line', count: 732 },
  { slug: 'heiliaodagua', name: '黑料大瓜', icon: 'ri-fire-line', count: 1683 },
  { slug: 'yulebagua', name: '娱乐八卦', icon: 'ri-film-line', count: 2105 },
  { slug: 'zongyiredian', name: '综艺热点', icon: 'ri-tv-line', count: 567 },
];

export const articles = [
  {
    id: 'article-1',
    title: '某千万粉网红私生活混乱被实锤？前助理深夜发文爆出惊人聊天记录',
    excerpt: '近日，一位拥有超过千万粉丝的头部网红被前助理深夜发文爆料，称其私生活极度混乱，并附上了多张聊天截图作为证据...',
    category: 'wanghong',
    categoryName: '网红爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20dark%20toned%20entertainment%20news%20visual%20with%20silhouette%20of%20a%20person%20holding%20phone%20in%20dim%20lighting%2C%20mysterious%20atmosphere%2C%20warm%20orange%20and%20deep%20shadow%20tones%2C%20editorial%20style%2C%20clean%20composition&width=800&height=500&seq=article-01&orientation=landscape',
    views: 128500,
    likes: 36200,
    comments: 8940,
    date: '2026-07-07',
    isHot: true,
    isNew: true,
    content: '<p>近日，一位拥有超过千万粉丝的头部网红被前助理深夜发文爆料，称其私生活极度混乱，并附上了多张聊天截图作为证据。</p><p>据前助理透露，该网红在镜头前塑造的"单纯人设"与私下行为完全不符。前助理称自己忍无可忍才选择公开这些信息，希望粉丝能够看清真相。</p><p>该爆料在社交平台迅速发酵，话题阅读量在短短两小时内突破5000万。目前该网红方面尚未对此事做出正式回应，但其社交账号评论区已被粉丝的质疑声淹没。</p><p>业内人士分析认为，如果爆料内容属实，该网红的商业价值将受到严重打击，多个品牌合作可能面临解约风险。</p>',
  },
  {
    id: 'article-2',
    title: '知名游戏主播被曝私下辱骂粉丝，直播道歉能否挽回口碑？',
    excerpt: '某平台头部游戏主播被曝光私下在粉丝群中频繁使用侮辱性词汇，引发大量粉丝脱粉...',
    category: 'zhubo',
    categoryName: '主播大瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20streamer%20setup%20with%20dark%20ambient%20lighting%2C%20moody%20atmosphere%2C%20empty%20gaming%20chair%20under%20dim%20red%20and%20orange%20lights%2C%20dramatic%20editorial%20composition%2C%20clean%20minimal%20background&width=800&height=500&seq=article-02&orientation=landscape',
    views: 96500,
    likes: 28400,
    comments: 6720,
    date: '2026-07-06',
    isHot: true,
    isNew: false,
    content: '<p>某平台头部游戏主播被曝光私下在粉丝群中频繁使用侮辱性词汇，这一消息在游戏圈内引起轩然大波。</p><p>曝光者提供了多张粉丝群聊天记录截图，显示该主播在深夜直播结束后，在核心粉丝群中使用了大量不当言论，涉及人身攻击和地域歧视等多个方面。</p><p>事件发酵后，该主播于次日发布视频道歉，称自己"一时情绪失控"，但网友们对此并不买账。截至发稿前，该主播已掉粉超过30万，多个厂商赞助也纷纷暂停合作。</p>',
  },
  {
    id: 'article-3',
    title: '时尚博主被扒穿假货多年，奢侈品鉴定师逐件打脸',
    excerpt: '一位拥有200万粉丝的时尚博主被专业人士逐件鉴定其展示的奢侈品，发现大量假货...',
    category: 'bozhu',
    categoryName: '博主反差',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20items%20displayed%20on%20dark%20surface%20with%20dramatic%20lighting%2C%20contrast%20between%20real%20and%20fake%20concept%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=500&seq=article-03&orientation=landscape',
    views: 152300,
    likes: 45800,
    comments: 12500,
    date: '2026-07-06',
    isHot: true,
    isNew: false,
    content: '<p>一位拥有200万粉丝的时尚博主被专业人士逐件鉴定其展示的奢侈品，结果令人大跌眼镜——大量展示品被鉴定为假货。</p><p>一位资深奢侈品鉴定师通过视频对该博主近两年发布的穿搭内容进行了逐一分析，发现其展示的超过70%的奢侈品包包和配饰均为仿品。该鉴定视频发布后引发热议，播放量迅速突破千万。</p><p>涉事博主目前已经关闭了评论区，并删除了大量历史内容。但网友们已经截图保存了大量证据，相关话题持续霸占各平台热搜。</p>',
  },
  {
    id: 'article-4',
    title: '娱乐圈某顶流被曝隐婚生子，前经纪人疑似幕后爆料',
    excerpt: '娱乐圈再度爆出重磅消息，某当红顶流被传已隐婚多年并育有一子，爆料者疑似其前经纪人...',
    category: 'heiliaodagua',
    categoryName: '黑料大瓜',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20silhouette%20of%20a%20person%20behind%20frosted%20glass%20with%20warm%20orange%20glow%2C%20secrecy%20and%20revelation%20concept%2C%20dramatic%20atmospheric%20lighting%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=article-04&orientation=landscape',
    views: 235600,
    likes: 78200,
    comments: 21300,
    date: '2026-07-05',
    isHot: true,
    isNew: false,
    content: '<p>娱乐圈再度爆出重磅消息，某当红顶流被传已隐婚多年并育有一子，爆料者疑似其前经纪人。</p><p>据知情人士透露，该艺人早在三年前就已秘密登记结婚，其配偶为圈外人士，两人育有一名两岁男孩。这一消息最先由一位自称是该艺人前经纪团队成员的账号发布。</p><p>该艺人工作室迅速发布声明否认，称将通过法律途径维权。但网友们发现声明中存在多处疑点，且该艺人近期多次被拍到进出某高档小区，与爆料中提到的住址高度吻合。</p>',
  },
  {
    id: 'article-5',
    title: '某选秀出道人设崩塌，多位同期选手齐发声揭露真相',
    excerpt: '正当红的选秀出身艺人被多位同期选手联合发声，揭露其比赛期间的种种不当行为...',
    category: 'yulebagua',
    categoryName: '娱乐八卦',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stage%20spotlight%20with%20dark%20shadows%20and%20orange%20warm%20glow%2C%20empty%20stage%20concept%2C%20dramatic%20contrast%20lighting%2C%20entertainment%20industry%20theme%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=article-05&orientation=landscape',
    views: 189200,
    likes: 56300,
    comments: 15800,
    date: '2026-07-05',
    isHot: false,
    isNew: true,
    content: '<p>正当红的选秀出身艺人被多位同期选手联合发声，揭露其比赛期间的种种不当行为，引发全网热议。</p><p>共有五位同期参赛选手在不同平台发布长文，详细描述了该艺人在比赛期间的霸凌行为、资源抢夺以及私下诋毁其他选手的情况。这些信息此前从未被公开。</p><p>该艺人粉丝群体反应激烈，有人选择脱粉，也有人坚持相信偶像并组织反击。这场风波让该艺人的公众形象遭受重大打击，多个待播项目前途未卜。</p>',
  },
  {
    id: 'article-6',
    title: '短视频平台网红夫妻被曝各玩各的，恩爱全是剧本？',
    excerpt: '一对在短视频平台拥有超5000万粉丝的夫妻档网红，被曝光私下感情早已破裂...',
    category: 'wanghong',
    categoryName: '网红爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20phones%20facing%20away%20from%20each%20other%20on%20dark%20surface%2C%20split%20screen%20lighting%20effect%2C%20warm%20orange%20and%20cool%20shadow%20contrast%2C%20relationship%20theme%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=article-06&orientation=landscape',
    views: 276800,
    likes: 92100,
    comments: 28400,
    date: '2026-07-04',
    isHot: true,
    isNew: false,
    content: '<p>一对在短视频平台拥有超5000万粉丝的夫妻档网红，被曝光私下感情早已破裂，镜头前的恩爱全部都是按照剧本表演。</p><p>据多方消息源证实，两人实际上已经分居超过一年，各自都有自己的社交圈子。但在短视频平台上，两人仍然保持着每天更新"甜蜜日常"的频率，以此维持商业合作和流量。</p><p>此消息曝光后，多个品牌方紧急暂停了与该夫妻的合作。有业内人士估算，如果事态继续发酵，两人可能面临超过千万的违约金赔偿。</p>',
  },
  {
    id: 'article-7',
    title: '综艺节目录制现场爆冲突，两位大咖艺人当场翻脸',
    excerpt: '某热门综艺节目最新一期录制现场发生意外冲突，两位重量级嘉宾因游戏环节产生争执...',
    category: 'zongyiredian',
    categoryName: '综艺热点',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20dramatic%20warm%20orange%20spotlight%20and%20deep%20shadows%2C%20empty%20seats%20facing%20each%20other%2C%20conflict%20tension%20concept%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=article-07&orientation=landscape',
    views: 198400,
    likes: 61300,
    comments: 18900,
    date: '2026-07-04',
    isHot: false,
    isNew: true,
    content: '<p>某热门综艺节目最新一期录制现场发生意外冲突，两位重量级嘉宾因游戏环节结果产生激烈争执，导致录制被迫中断近两小时。</p><p>据现场工作人员透露，冲突起因是其中一个游戏环节的判罚争议。双方各执一词，互不相让，最终在镜头前爆发了激烈的言语对抗。节目组紧急出面调解，录制才得以继续。</p><p>此事曝光后，网友们纷纷站队，相关话题在社交平台持续霸榜。节目组尚未对此事做出正式回应，但据悉该期节目可能会进行大量剪辑后再播出。</p>',
  },
  {
    id: 'article-8',
    title: '知名美食博主被曝食材造假，所谓"家传秘方"竟是外卖？',
    excerpt: '一位以"家传秘方"走红的美食博主，被网友实锤其视频中展示的菜品实际是点外卖...',
    category: 'bozhu',
    categoryName: '博主反差',
    imageUrl: 'https://readdy.ai/api/search-image?query=Takeout%20food%20containers%20hidden%20behind%20elegant%20tableware%2C%20deception%20concept%2C%20warm%20orange%20kitchen%20lighting%20with%20dark%20shadows%2C%20editorial%20food%20photography%2C%20clean%20composition&width=800&height=500&seq=article-08&orientation=landscape',
    views: 114700,
    likes: 35200,
    comments: 9800,
    date: '2026-07-03',
    isHot: false,
    isNew: false,
    content: '<p>一位以"家传秘方"走红的美食博主，被网友实锤其视频中展示的菜品实际是从外卖平台订购后重新摆盘。</p><p>细心的网友发现，该博主视频中出现的菜品与某外卖平台某商家的菜品在外观、配料乃至摆盘方式上都高度一致。经过多期视频的逐帧对比，网友确认该博主所谓的"亲手制作"实为外卖食物的重新包装。</p><p>面对铺天盖地的质疑，该博主最终发布道歉视频，承认确实存在造假行为，称因为"时间紧张"才选择这种方式。但网友们普遍认为这个解释缺乏诚意，该博主账号在一周内掉粉超过80万。</p>',
  },
];

export const siteInfo = {
  name: '51吃瓜网',
  tagline: '今日吃瓜资源网站 — 在线吃瓜爆料视频每日更新',
  description: '51吃瓜网今日吃瓜资源网站提供app下载通道与在线吃瓜入口，每日更新最新吃瓜爆料视频，覆盖网红、主播、博主反差内容，实时追踪黑料大瓜，是吃瓜群众获取一手资源的核心发布页。',
  downloadUrl: '#download',
  stats: {
    dailyVisits: '580万+',
    totalArticles: '12万+',
    activeUsers: '320万+',
    appDownloads: '890万+',
  },
};

export const categoryImages: Record<string, string> = {
  wanghong: 'https://readdy.ai/api/search-image?query=Social%20media%20influencer%20aesthetic%20with%20smartphone%20and%20ring%20light%2C%20warm%20orange%20ambient%20glow%2C%20dark%20moody%20background%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=cat-wanghong&orientation=landscape',
  zhubo: 'https://readdy.ai/api/search-image?query=Live%20streaming%20setup%20with%20microphone%20and%20monitor%20in%20dark%20room%20with%20warm%20neon%20glow%2C%20gaming%20atmosphere%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=cat-zhubo&orientation=landscape',
  bozhu: 'https://readdy.ai/api/search-image?query=Professional%20camera%20on%20tripod%20in%20dark%20studio%20with%20warm%20golden%20rim%20light%2C%20content%20creator%20aesthetic%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=cat-bozhu&orientation=landscape',
  heiliaodagua: 'https://readdy.ai/api/search-image?query=Dramatic%20breaking%20news%20concept%20with%20glowing%20headlines%20in%20dark%20space%2C%20warm%20red%20and%20orange%20accents%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=cat-heiliao&orientation=landscape',
  yulebagua: 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20theme%20with%20spotlight%20and%20velvet%20curtain%20in%20dark%20theater%2C%20warm%20golden%20glow%2C%20dramatic%20lighting%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=cat-yule&orientation=landscape',
  zongyiredian: 'https://readdy.ai/api/search-image?query=TV%20show%20production%20set%20with%20studio%20lights%20in%20dark%20environment%2C%20warm%20orange%20backlight%2C%20variety%20show%20aesthetic%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=cat-zongyi&orientation=landscape',
};